import $ from 'jquery';

$(function () {
  var activateBrandingForm;
  var dismissibleAlert;
  var setLabel;
  var clearAlerts;

  if ($('.brandings').length) {
    $('.js-custom-link-text').click(function () {
      $('.js-custom-link-text-group').removeClass('hidden');
      $('.js-custom-link-image-group').addClass('hidden');
    });

    $('.js-custom-link-image').click(function () {
      $('.js-custom-link-image-group').removeClass('hidden');
      $('.js-custom-link-text-group').addClass('hidden');
    });

    $('.brandings').on('ajax:complete', function (evt) {
      var branding;
      var company;
      var errorMessages;
      var errors;
      var responseObject;

      const [data] = evt.detail;

      var $panels = $('.js-accordion:first');
      clearAlerts();

      if (data.status == 200) {
        responseObject = JSON.parse(data.responseText);
        branding = responseObject.branding;
        company = responseObject.company;
        $('.panel.collapse').removeClass('in');
        if (branding) {
          setLabel(branding);
          $panels.prepend(
            dismissibleAlert(
              'success',
              "You've successfully updated " + branding.name + '</div>',
            ),
          );
        } else if (company) {
          $panels.prepend(
            dismissibleAlert(
              'success',
              "You've successfully updated " +
                responseObject.company.name +
                '</div>',
            ),
          );
        } else {
          $panels.prepend(
            dismissibleAlert(
              'success',
              "You've successfully updated " + responseObject.name + '</div>',
            ),
          );
        }
      } else {
        errorMessages = JSON.parse(data.responseText).errors;
        errors = $panels.prepend(dismissibleAlert('danger', errorMessages));
        $('body, html').animate(
          {
            scrollTop: errors.offset().top,
          },
          1000,
        );
      }
    });

    dismissibleAlert = function (type, msg) {
      var closeButton =
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>';
      return (
        '<div class="alert alert-' +
        type +
        ' alert-dismissible" role="alert">' +
        closeButton +
        msg +
        '</div>'
      );
    };

    clearAlerts = function () {
      $('div.alert').remove();
    };

    setLabel = function (branding) {
      var $currentPanel = $('div').find(
        "[data-subdomain='" + branding.id + "']",
      );
      var key = $currentPanel.data('key');
      var $label = $currentPanel.find('.js-label');
      var functionHash = {
        social: function () {
          var labelText = branding.social_action
            ? branding.social_action.toUpperCase()
            : 'OFF';
          var labelClass = branding.social_action ? 'popular' : 'none';
          $label.removeClass('none popular');
          $label.addClass(labelClass);
          $label.text(labelText);
        },
        enabled: function () {
          branding.enabled
            ? $label.removeClass('hidden')
            : $label.addClass('hidden');
          $currentPanel.find('.js-branding-name').html(branding.name);
          $('.js-save-branding-' + branding.id).val('Save ' + branding.name);
        },
      };
      functionHash[key]();
    };

    activateBrandingForm = function () {
      $('.js-social-action-div').each(function () {
        if ($(this).find('.js-social-action-radio').is(':checked')) {
          $(this).removeClass('inactive-action');
        } else {
          $(this).addClass('inactive-action');
        }
      });
    };

    $('.js-social-action-radio').change(function () {
      activateBrandingForm();
    });

    $('.js-twitter-handle').change(function () {
      var brand = this.dataset.brand;
      $('.js-twitter-handle[data-brand="' + brand + '"]').val(this.value);
    });

    activateBrandingForm();
  }
});
